import * as React from "react";
import { Stack, Box, Typography } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { NavigationType } from "@/components/header/common/header-enums";
import { useTranslations } from "next-intl";

type MobileSecondaryNavigationHeaderProps = {
  currentPrimaryNavLabel: string;
  setActiveNavigation: (activeNavigation: NavigationType) => void;
};
export default function MobileSecondaryNavigationHeader(props: MobileSecondaryNavigationHeaderProps) {
  const { currentPrimaryNavLabel, setActiveNavigation } = props;
  const t = useTranslations("COMMON");
  return (
    <Stack
      sx={{
        position: "fixed",
        zIndex: 1000,
        width: "100%",
        height: "60px",
        backgroundColor: "background.default",
        boxShadow: 10,
        overflowX: "hidden"
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%"
        }}
      >
        <Box
          sx={{
            display: "flex",
            height: "60px",
            alignItems: "center",
            pl: 2,
            cursor: "pointer",
            flexShrink: 0
          }}
          onClick={() => { setActiveNavigation(NavigationType.primary); }}>
          <KeyboardArrowLeftIcon
            sx={{
              display: "block",
              fontSize: "2.5rem",
              fontWeight: "600",
              marginTop: "1rem",
              mb: 1.2
            }}
          />
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "400",
              color: "text.primary"
            }}
          >
            {t("Back")}
          </Typography>
        </Box>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "left",
            px: 2,
            minWidth: 0
          }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: "700",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}
          >
            {currentPrimaryNavLabel}
          </Typography>
        </Box>
        <Box
          sx={{
            width: { xs: "30px", sm: "50px" },
            flexShrink: 0
          }}
        />
      </Box>
    </Stack>
  );
}
